export default __webpack_public_path__ + "static/media/footer_bg.6bb518ba.jpg";